import { VFields } from './v-fields';
import { Response } from './response';
import { FileHelper } from '../helper/file.helper';

export function addAttachmentsFields(vm: any): Array<VFields<any>> {
    return [{
        key: 'roNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
            counter: 50,
            label: vm.$parent.$t('repairOrderAttachments.roNumber') as string,
            required: true,
            disabled: true,
            elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
            loading: false,
            rules: [
                v => vm.required('Ro Number', v)
            ]
        },
    },
    {
        key: 'customerName',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
            label: vm.$parent.$t('repairOrderAttachments.customerName') as string,
            required: true,
            disabled: true,
            elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
            loading: false,
            rules: [
                v => vm.required('Customer Name', v)
            ]
        },
    },
    {
        key: 'vehicleIdNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
            label: vm.$parent.$t('repairOrderAttachments.vinNumber') as string,
            required: true,
            disabled: true,
            elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
            loading: false,
            rules: [
                v => vm.required('VIN Number', v)
            ]
        },
    },
    {
        key: 'make',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
            label: vm.$parent.$t('repairOrderAttachments.make') as string,
            required: false,
            disabled: true,
            elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
            loading: false,
            // rules:[
            //     v => vm.required('Make',v)
            // ]
        },
    },
    {
        key: 'model',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
            label: vm.$parent.$t('repairOrderAttachments.model') as string,
            required: false,
            disabled: true,
            elementClass: 'col-12 col-xs-6 col-sm-6 col-md-3 col-lg-3 float-left',
            loading: false,
            // rules:[
            //     v => vm.required('Model',v)
            // ]
        },
    },
    {
        key: 'attachmentTypeId',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
            label: vm.$parent.$t('repairOrderAttachments.attachmentType') as string,
            // validations: 'required',
            required: true,
            disabled: false,
            time: true,
            value: 'id',
            text: 'name',
            items: vm.attachmentTypes,
            elementClass: 'col-12 col-xs-6 col-sm-6 col-md-3 col-lg-3 float-left',
            altag: 'Attachment Type',
            loading: false,
            rules: [
                v => vm.required('Attachment Type', v)
            ]
        },
    },
    {
        key: 'isPublic',
        type: 'v-alynk-switch',
        required: false,
        templateOptions: {
            label: vm.$parent.$t('repairOrderAttachments.isPublic') as string,
            disabled: false,
            validations: '',
            loading: false,
            elementClass: 'col-12 col-xs-6 col-sm-6 col-md-3 col-lg-3 float-left',
        },
    },

    {
        key: 'file',
        type: 'v-alynk-file-upload',
        required: true,
        templateOptions: {
            label: vm.$parent.$t('repairOrderAttachments.attachment') as string,
            required: true,
            disabled: false, multiple: false,
            elementClass: 'mt-4',
            events: {
                onChange: (files, ref) => {
                    if (files.length > 0) {
                        vm.fileRef = ref;
                        // tslint:disable-next-line: max-line-length
                        vm.addAttachmentTypeModel.fileExtension = files[0].file.name.substring(files[0].file.name.lastIndexOf('.'));
                        FileHelper.getFileBytes(files[0].file, (base64) => {
                            vm.addAttachmentTypeModel.file = base64;
                        });
                    }
                },
            },
            loading: false,
            rules: [
                v => vm.required('Attachment', v)
            ]
        },
    },
    {
        key: 'comment',
        type: 'v-alynk-textarea',
        required: false,
        templateOptions: {
            counter: 250,
            maxlength: 250,
            label: vm.$parent.$t('repairOrderAttachments.comment') as string,
            required: false,
            disabled: false,
            loading: false,
            elementClass: 'col-12 float-left mt-4',
        },

    }];
}


export function addCustomUploaderAttachmentFields(vm: any): Array<VFields<any>> {
    return [{
        key: 'roNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
            counter: 50,
            label: vm.$parent.$t('repairOrderAttachments.roNumber') as string,
            required: true,
            disabled: true,
            elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
            loading: false,
            rules: [
                v => vm.required('Ro Number', v)
            ]
        },
    },
    {
        key: 'customerName',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
            label: vm.$parent.$t('repairOrderAttachments.customerName') as string,
            required: true,
            disabled: true,
            elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
            loading: false,
            rules: [
                v => vm.required('Customer Name', v)
            ]
        },
    },
    {
        key: 'vehicleIdNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
            label: vm.$parent.$t('repairOrderAttachments.vinNumber') as string,
            required: true,
            disabled: true,
            elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
            loading: false,
            rules: [
                v => vm.required('VIN Number', v)
            ]
        },
    },
    {
        key: 'make',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
            label: vm.$parent.$t('repairOrderAttachments.make') as string,
            required: true,
            disabled: true,
            elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
            loading: false,
            // rules:[
            //     v => vm.required('Make',v)
            // ]
        },
    },
    {
        key: 'model',
        type: 'v-alynk-text-field',
        required: false,
        templateOptions: {
            label: vm.$parent.$t('repairOrderAttachments.model') as string,
            required: true,
            disabled: true,
            elementClass: 'col-12 col-xs-6 col-sm-6 col-md-3 col-lg-3 float-left',
            loading: false,
            // rules:[
            //     v => vm.required('Model',v)
            // ]
        },
    },
    {
        key: 'attachmentTypeId',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
            label: vm.$parent.$t('repairOrderAttachments.attachmentType') as string,
            // validations: 'required',
            required: true,
            disabled: false,
            time: true,
            value: 'id',
            text: 'name',
            items: vm.attachmentTypes,
            elementClass: 'col-12 col-xs-6 col-sm-6 col-md-3 col-lg-3 float-left',
            altag: 'Attachment Type',
            loading: false,
            rules: [
                v => vm.required('Attachment Type', v)
            ]
        },
    },
    {
        key: 'isPublic',
        type: 'v-alynk-switch',
        required: false,
        templateOptions: {
            label: vm.$parent.$t('repairOrderAttachments.isPublic') as string,
            disabled: false,
            validations: '',
            loading: false,
            elementClass: 'col-12 col-xs-6 col-sm-6 col-md-3 col-lg-3 float-left',
        },
    },
    {
        key: 'comment',
        type: 'v-alynk-textarea',
        required: false,
        templateOptions: {
            counter: 250,
            label: vm.$parent.$t('repairOrderAttachments.comment') as string,
            required: false,
            disabled: false,
            loading: false,
            elementClass: 'col-12 float-left',
        },
    }];
}
